export type WOAction = {
  label: string;
  buttonType: "primary" | "default";
  action: "start" | "review" | "delay" | "done" | "confirm" | "reject";
};

type WOStatusTransition = {
  management: WOAction[];
  field: WOAction[];
};

export const WO_STATUS_TRANSITIONS: Record<string, WOStatusTransition> = {
  NEW: {
    management: [{ label: "Start Work Order", buttonType: "primary", action: "start" }],
    field: [{ label: "Start Work Order", buttonType: "primary", action: "start" }],
  },
  IN_PROGRESS: {
    management: [
      { label: "Mark In Review", buttonType: "primary", action: "review" },
      { label: "Report Standby", buttonType: "default", action: "delay" },
    ],
    field: [
      { label: "Complete", buttonType: "primary", action: "done" },
      { label: "Report Standby", buttonType: "default", action: "delay" },
    ],
  },
  STANDBY: {
    management: [{ label: "Resume Work Order", buttonType: "primary", action: "start" }],
    field: [{ label: "Resume Work Order", buttonType: "primary", action: "start" }],
  },
  IN_REVIEW: {
    management: [
      { label: "Confirm", buttonType: "primary", action: "confirm" },
      { label: "Reject", buttonType: "default", action: "reject" },
    ],
    field: [],
  },
  DONE: {
    management: [],
    field: [],
  },
};
